<template>
  <header class="header">
    <h1>{{ pageName }}</h1>

    <div class="header-action">
      <div class="header-action__user">
        <p class="user-info">
          Merhaba,
          <span>
            {{ getUserInfo.name }}
            <span v-if="getUserInfo.surName">
              {{ getUserInfo.surName }}
            </span>
          </span>
        </p>
        <div
          v-on:click="toggleMenu"
          class="header-action__user-avatar toggle-dropdown"
          id="header-action__user-avatar"
        >
          <base-icon name="person" class="toggle-dropdown" />
        </div>
      </div>
    </div>

    <dropdown-menu
      :isMenuDisplayed="isMenuDisplayed"
      :toggleMenu="toggleMenu"
    ></dropdown-menu>
    <div v-if="displayEnv" class="fixed">{{ envText }}</div>
  </header>
</template>

<script>
import { BaseIcon } from "@/components";
import DropdownMenu from "./DropdownMenu";
import { mapGetters } from "vuex";

export default {
  name: "TopBar",
  components: {
    BaseIcon,
    DropdownMenu,
  },

  data() {
    return {
      menuItems: [
        { iconName: "settings", name: "Ayarlar" },
        { iconName: "log-out", name: "Çıkış" },
      ],
      isMenuDisplayed: false,
      displayEnv: false,
      envText: null,
    };
  },
  methods: {
    toggleMenu({ isOutside = false }) {
      if (isOutside) this.isMenuDisplayed = false;
      else this.isMenuDisplayed = !this.isMenuDisplayed;
    },
    getPageName() {
      this.pageName =
        this.$route?.name == "RepresReports"
          ? "Müşteri Raporları"
          : "Müşteriler";
    },
  },
  computed: {
    ...mapGetters(["getUserInfo"]),
    pageName() {
      const name = this.$route?.meta.mainTitle;
      if (name !== undefined) {
        return name;
      }
      return "";
    },
  },
  mounted() {
    if (
      process.env.VUE_APP_MODE !== "library" ||
      process.env.VUE_APP_MODE !== "PRODUCTION"
    ) {
      this.envText = process.env.VUE_APP_MODE;
    }
  },
};
</script>

<style lang="scss" scoped>
.header {
  background: var(--grayscale-0);
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 60px;
  padding: 5px 20px;
  border-bottom: 1px solid;
  border-color: var(--grayscale-30);

  h1 {
    font-size: 24px;
    color: var(--color-body-text);
  }
  @media (max-width: 410px) {
    flex-wrap: wrap;
    padding-bottom: 20px;
    height: auto;
    padding-top: 20px;
    h1 {
      margin-bottom: 20px;
    }
  }
  .fixed {
    position: fixed;
    top: 0px;
    right: 0px;
    background: #000;
    color: red;
    font-size: 18px;
    padding: 3px;
    animation: myanimation 3s infinite;
    font-weight: bold;
    border: 1px solid #ccc;

    @keyframes myanimation {
      0% {
        color: red;
      }
      25% {
        color: yellow;
      }
      50% {
        color: green;
      }
      75% {
        color: brown;
      }
      100% {
        color: red;
      }
    }
  }
}

.header-action {
  display: flex;
  align-items: center;
  justify-content: space-between;

  &__icons {
    margin: 0 20px;

    svg {
      cursor: pointer;
      margin: 0 10px;
    }

    @media only screen and (max-width: 600px) {
      margin: 0;
    }
  }

  &__user {
    display: flex;
    align-items: center;
    min-width: 120px;
    .user-info {
      margin: 0 15px 0 5px;
      font-size: 14px;
      span {
        font-weight: 700;
      }
    }
  }

  &__user-avatar {
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    width: 40px;
    height: 40px;
    border-radius: 999px;
    background: var(--grayscale-20);
    @media (max-width: 410px) {
      order: -1;
      margin-right: 3px;
    }
  }
}
</style>
